import useOrganizationFlags from '@/modules/auth/composables/use-organization-flags'
import { useLocalStorage } from '@vueuse/core'
import { computed } from 'vue'

const localOverride = useLocalStorage<'v1' | 'v2' | null>('design_version', null)

export function useDesignVersion() {
    const { hasFlag } = useOrganizationFlags()
    return {
        isV2: computed(() => localOverride.value !== 'v1' && (localOverride.value === 'v2' || hasFlag('design_v2'))),
    }
}

/**
 * Non-reactive read — safe to call outside component setup (e.g. router).
 * Returns the current flag value at call time.
 */
export function getIsV2(): boolean {
    return localOverride.value !== 'v1' && (localOverride.value === 'v2' || useOrganizationFlags().hasFlag('design_v2'))
}
